/**
 * True when an axios error carries the backend's "token expired" string body.
 *
 * The body is only sometimes a string. Routes that fail through the JsonFormatError carrier
 * return a JSON object, and a network failure has no `response` at all - so the bare
 * `err.response.data.split(' ')` this replaces throws a TypeError *inside* the catch block,
 * which swallows the real error and leaves the UI with nothing to show.
 */
export function isTokenExpired(err) {
  const data = err && err.response && err.response.data;
  return typeof data === 'string' && data.split(' ').includes('expired');
}

/**
 * The message to show the user for a failed request, whatever shape the body arrived in.
 *
 * Handles the three shapes in use: a plain string body, Laravel's `{ message, errors }`, and no
 * response at all (network failure, request cancelled).
 */
export function errorMessage(err, fallback = 'Something went wrong. Please try again.') {
  const data = err && err.response && err.response.data;

  if (typeof data === 'string' && data) {
    return data;
  }

  if (data && typeof data === 'object') {
    const firstValidationError = data.errors ? Object.values(data.errors).flat()[0] : null;

    if (data.message && firstValidationError) {
      return `${data.message} ${firstValidationError}`;
    }
    if (data.message) {
      return data.message;
    }
    if (data.error && data.error.message) {
      return data.error.message;
    }
  }

  return (err && err.message) || fallback;
}
